import { z } from 'zod';

export const BatteryUpdateSchema = z.object({
  device: z.string(),
  battery: z.number(),
});

export type BatteryUpdate = z.infer<typeof BatteryUpdateSchema>;
